import { addWatermarkToImage } from "helpers";
import { useState } from "react";

const useImagesWatermarks = () => {
  const [processingImagesCount, setProcessingImagesCount] = useState(0);

  const addWatermarkToImages = async (files: File[], watermarkText: string) => {
    setProcessingImagesCount(files.length);

    const processedFiles = await Promise.all(
      files.map(async (file) =>
        file.type.startsWith("image")
          ? await addWatermarkToImage(file, watermarkText)
          : file
      )
    );

    setProcessingImagesCount(0);

    return processedFiles;
  };

  return { processingImagesCount, addWatermarkToImages };
};

export default useImagesWatermarks;
